import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import DisabledButtonWithTooltip from '@atlassian/jira-disabled-button-with-tooltip/src/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardBaseStyle = styled.a<{ isSelected?: boolean }>(
	{
		display: 'block',
		paddingBlockStart: token('space.150'),
		paddingBlockEnd: token('space.150'),
		paddingInlineStart: token('space.150'),
		paddingInlineEnd: token('space.150'),
		boxSizing: 'border-box',
		boxShadow: token('elevation.shadow.raised'),
		borderRadius: token('radius.small'),
		marginBlockStart: token('space.025'), // small margin needed so box shadow is visible.
		marginBlockEnd: token('space.025'), // small margin needed so box shadow is visible.
		marginInlineStart: token('space.025'), // small margin needed so box shadow is visible.
		marginInlineEnd: token('space.025'), // small margin needed so box shadow is visible.
		'&:hover': {
			textDecoration: 'none',
		},
		'&:focus': {
			boxShadow: `${token('color.border.focused')} 0 0 0 2px inset`,
			textDecoration: 'none',
			outline: 'none',
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	({ isSelected }) => ({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
		backgroundColor: isSelected
			? token('color.background.accent.blue.subtlest')
			: token('elevation.surface.raised'),
	}),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FullHeightDisabledButton = styled(DisabledButtonWithTooltip)({
	height: '100%',
});
